/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportResponseList } from '../../models/import-response-list';
import { MessageBulkList } from '../../models/message-bulk-list';

export interface ApiMessageBulkPost$Params {
      body: MessageBulkList
}

export function apiMessageBulkPost(http: HttpClient, rootUrl: string, params: ApiMessageBulkPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResponseList>> {
  const rb = new RequestBuilder(rootUrl, apiMessageBulkPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportResponseList>;
    })
  );
}

apiMessageBulkPost.PATH = '/api/message/bulk';
